export default (
  state = {
    appVersion: {
      newVersionFound: false,
      isMajorRelease: null,
      oldVersion: "",
      newVersion: "",
    },
    authData: false,
    currentUserPermissions: [],
    hasUnseenInboxNotifications: false,
    pricingInfo: {},
    billingInfo: {},
    metering: {},
  },
  action,
) => {
  switch (action.type) {
    case "TRIGGER_NEW_APP_NOTIFICATION":
      return {
        ...state,
        appVersion: action.payload,
      };
    case "CHANGE_AUTH":
      return {
        ...state,
        authData: action.payload,
      };
    case "CURRENT_USER_PERMISSIONS":
      return {
        ...state,
        currentUserPermissions: action.payload,
      };

    case "INBOX_SEEN_UNSEEN_NOTIFICATIONS":
      return {
        ...state,
        hasUnseenInboxNotifications: action.payload,
      };

    case "FETCH_PRICING_INFO":
      return {
        ...state,
        pricingInfo: action.payload,
      };

    case "UPDATE_METERING_VALUES":
      return {
        ...state,
        metering: action.payload,
      };

    case "FETCH_BILLING_INFO":
      return {
        ...state,
        billingInfo: action.payload,
      };
    default:
      return state;
  }
};
